import { memo } from 'react';
import { ReactGrid } from '@silevis/reactgrid';
import { Box } from '@chakra-ui/react';

import { handleCanReorderRows } from '../TableHelpersOpz';

type GridProperties = {
  rows: any;
  columns: any;
  gridProperties: Record<string, unknown>;
  customCellTemplates: Record<string, unknown>;
  onRowsReordered: (targetRowId: any, rowIds: any[]) => void | Promise<void>;
  onFocusLocationChanging: () => boolean;
  onFocusLocationChanged: (data: any) => void;
  onCellsChanged: (changes: any) => void;
  onContextMenu?: (
    selectedRowIds: any,
    selectedColIds: any,
    selectionMode: any,
    menuOptions: any,
    selectedRanges: any,
  ) => any;
  onColumnResized?: (ci: any, width: any) => void;
  stickyBottomRows?: number;
};

const PropertyTableReactGrid = memo(function PropertyTableReactGrid({
  rows,
  columns,
  gridProperties,
  customCellTemplates,
  onRowsReordered,
  onFocusLocationChanging,
  onFocusLocationChanged,
  onCellsChanged,
  onContextMenu,
  onColumnResized,
  stickyBottomRows,
}: GridProperties) {
  const resolvedStickyBottomRows = stickyBottomRows ?? (rows?.length <= 3 ? 0 : 1);

  return (
    <Box
      className='property-table-container sm-scroll'
      width={'100%'}
      flex={1}
      minW={0}
      margin={'initial'}
      maxH={'initial'}
      overflowY={rows.length > 10 ? 'auto' : 'initial'}
    >
      <ReactGrid
        rows={rows}
        columns={columns}
        enableRowSelection={rows?.length > 3}
        stickyTopRows={rows?.length <= 3 ? 0 : 1}
        stickyRightColumns={columns?.length <= 2 ? 0 : 1}
        stickyLeftColumns={columns?.length <= 2 ? 0 : 1}
        stickyBottomRows={resolvedStickyBottomRows}
        verticalStickyBreakpoint={100}
        horizontalStickyBreakpoint={100}
        canReorderRows={handleCanReorderRows}
        onRowsReordered={onRowsReordered}
        {...gridProperties}
        onFocusLocationChanging={onFocusLocationChanging}
        onFocusLocationChanged={onFocusLocationChanged}
        onCellsChanged={onCellsChanged}
        onContextMenu={onContextMenu}
        onColumnResized={onColumnResized}
        customCellTemplates={customCellTemplates as any}
      />
    </Box>
  );
});

export default PropertyTableReactGrid;
